import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-0 p-[15px] md:p-[20px] rounded-md flex flex-col h-full" }
const _hoisted_2 = { class: "trezo-card-header sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "relative ltr:mr-[15px] rtl:ml-[15px]" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "font-semibold block text-black dark:text-white text-md" }
const _hoisted_9 = {
  key: 0,
  class: "mt-[2px]"
}
const _hoisted_10 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0 flex items-center gap-[15px]" }
const _hoisted_11 = { class: "relative inline-flex items-center" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "absolute top-full right-0 mt-2 w-48 bg-white dark:bg-[#0c1427] shadow-lg rounded-md z-50 border border-gray-200 dark:border-[#172036]"
}
const _hoisted_15 = {
  key: 0,
  class: "px-3 py-2 border-b border-gray-200 dark:border-[#172036] text-xs"
}
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "max-h-40 overflow-y-auto py-1" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "trezo-card-content flex flex-col flex-grow overflow-hidden" }
const _hoisted_21 = { class: "chat-body calc-height overflow-y-auto ltr:-mr-[10px] rtl:-ml-[10px] flex flex-col-reverse" }
const _hoisted_22 = { class: "flex flex-col ltr:pl-[0px] ltr:pr-[10px] rtl:pr-[10px] rtl:pl-[10px] pb-[5px] w-full" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "mb-[5px] last:mb-0" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["src", "onClick"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  controls: "",
  class: "max-w-full"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "chat-form mt-[10px] relative" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "absolute ltr:right-0 rtl:left-0 top-0 h-full w-[150px] flex items-center justify-end ltr:pr-[13px] rtl:pl-[13px] gap-[9px]" }
const _hoisted_35 = {
  key: 0,
  class: "emoji-picker fixed bottom-auto right-auto bg-white dark:bg-[#0c1427] p-2 rounded-md shadow-xl z-[100] w-[300px] h-[350px] overflow-hidden",
  style: {"transform":"translateY(-360px)"}
}
const _hoisted_36 = { class: "emoji-tabs flex border-b border-gray-200 dark:border-[#172036] mb-2" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "text-xs font-medium mb-1 px-1" }
const _hoisted_39 = { class: "emoji-grid h-[295px] overflow-y-auto px-1" }
const _hoisted_40 = { class: "grid grid-cols-8 gap-1" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args))),
                class: "inline-block transition-all hover:text-primary-500 ltr:mr-[10px] rtl:ml-[10px]",
                "aria-label": _ctx.directT('chat.backToList')
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-xl" }, " arrow_back ", -1)
              ]), 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.chatUser.profile_picture_url || _ctx.chatUser.image,
              alt: "user-image",
              class: "rounded-full w-[75px]"
            }, null, 8, _hoisted_7),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "absolute bg-success-500 w-[10px] h-[10px] rounded-full border-[2px] border-white dark:border-[#0c1427] bottom-[5px] ltr:right-[5px] rtl:left-[5px]" }, null, -1))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.chatUser.name || _ctx.chatUser.phone), 1),
            (_ctx.chatUser.phone && _ctx.chatUser.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.chatUser.phone), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAssignDropdown && _ctx.toggleAssignDropdown(...args))),
            class: "inline-flex items-center justify-center h-8 w-8 transition-all hover:text-primary-500 relative",
            title: _ctx.assignedToName ? `Assigned to ${_ctx.assignedToName}` : 'Assign to user'
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " person_add ", -1)),
            (_ctx.assignedToName)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "absolute -top-1 -right-1 w-3 h-3 bg-primary-500 rounded-full",
                  title: _ctx.assignedToName
                }, null, 8, _hoisted_13))
              : _createCommentVNode("", true)
          ], 8, _hoisted_12),
          (_ctx.showAssignDropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_ctx.assignedToName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.directT('chat.assignedTo') || 'Assigned to') + ": ", 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.assignedToName), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgUsers, (user) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: user.user_id,
                      onClick: ($event: any) => (_ctx.assignToUser(user.user_id)),
                      class: "px-3 py-2 hover:bg-gray-100 dark:hover:bg-[#172036] cursor-pointer"
                    }, _toDisplayString(user.display_name), 9, _hoisted_18))
                  }), 128)),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unassignUser && _ctx.unassignUser(...args))),
                    class: "px-3 py-2 hover:bg-gray-100 dark:hover:bg-[#172036] cursor-pointer text-danger-500"
                  }, _toDisplayString(_ctx.directT('chat.unassign') || 'Unassign'), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({
            'inline-flex items-center justify-center h-8 w-8 transition-all hover:text-primary-500 rounded-full p-1': true,
            'bg-success-500 shadow-md': _ctx.chatUser.botstatus === true,
            'bg-danger-500 shadow-md': _ctx.chatUser.botstatus === false
          }),
          title: _ctx.chatUser.botstatus ? 'Bot is active' : 'Bot is inactive',
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleBotStatus && _ctx.toggleBotStatus(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["material-symbols-outlined !text-md", {'text-white font-bold': _ctx.chatUser.botstatus !== undefined}])
          }, " smart_toy ", 2)
        ], 10, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "border-t border-gray-100 dark:border-[#172036] mt-[20px] mb-[18px]" }, null, -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("ul", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass({
              'relative w-full md:w-full ltr:text-right md:rtl:text-left md:ltr:mr-auto rtl:ml-auto': message.from_our_customer,
              'relative ltr:pl-[40px] rtl:pr-[40px] w-full md:w-full': !message.from_our_customer
            })
            }, [
              (!message.from_our_customer)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.chatUser.profile_picture_url || _ctx.chatUser.image,
                    width: "35",
                    alt: "user",
                    class: "rounded-full top-0 ltr:left-0 rtl:right-0 absolute"
                  }, null, 8, _hoisted_23))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass({'ltr:text-right rtl:text-left': message.from_our_customer, 'ltr:text-left rtl:text-right': !message.from_our_customer})
              }, [
                _createElementVNode("div", _hoisted_24, [
                  (message.type === 'text')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass({
                    'py-[10px] px-[15px] inline-block bg-primary-500 text-white ltr:rounded-l-md rtl:rounded-l-md max-w-[90%] break-words whitespace-pre-wrap': message.from_our_customer,
                    'py-[10px] px-[15px] inline-block bg-gray-50 dark:bg-[#15203c] ltr:rounded-r-md rtl:rounded-l-md max-w-[90%] break-words whitespace-pre-wrap': !message.from_our_customer
                  }),
                        innerHTML: _ctx.formatMessageText(message.text)
                      }, null, 10, _hoisted_25))
                    : (message.type === 'image' || message.type === 'photo')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass({
                    'py-[5px] px-[5px] inline-block bg-primary-500 text-white ltr:rounded-l-md rtl:rounded-l-md max-w-[90%]': message.from_our_customer,
                    'py-[5px] px-[5px] inline-block bg-gray-50 dark:bg-[#15203c] ltr:rounded-r-md rtl:rounded-l-md max-w-[90%]': !message.from_our_customer
                  })
                        }, [
                          _createElementVNode("img", {
                            src: message.link,
                            alt: "Image",
                            class: "max-w-full rounded-md max-h-[300px] cursor-pointer",
                            onClick: ($event: any) => (_ctx.openImageInNewTab(message.link))
                          }, null, 8, _hoisted_26),
                          (message.text)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "mt-2 px-2 text-sm",
                                innerHTML: _ctx.formatMessageText(message.text)
                              }, null, 8, _hoisted_27))
                            : _createCommentVNode("", true)
                        ], 2))
                      : (message.type === 'audio' || message.type === 'voice')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass({
                    'py-[10px] px-[15px] inline-block bg-primary-500 text-white ltr:rounded-l-md rtl:rounded-l-md max-w-[90%]': message.from_our_customer,
                    'py-[10px] px-[15px] inline-block bg-gray-50 dark:bg-[#15203c] ltr:rounded-r-md rtl:rounded-l-md max-w-[90%]': !message.from_our_customer
                  })
                          }, [
                            _createElementVNode("audio", _hoisted_28, [
                              _createElementVNode("source", {
                                src: message.link,
                                type: "audio/mpeg"
                              }, null, 8, _hoisted_29),
                              _cache[11] || (_cache[11] = _createTextVNode(" Your browser does not support the audio element. "))
                            ]),
                            (message.text)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "mt-2",
                                  innerHTML: _ctx.formatMessageText(message.text)
                                }, null, 8, _hoisted_30))
                              : _createCommentVNode("", true)
                          ], 2))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 3,
                            class: _normalizeClass({
                    'py-[10px] px-[15px] inline-block bg-primary-500 text-white ltr:rounded-l-md rtl:rounded-l-md max-w-[90%] break-words whitespace-pre-wrap': message.from_our_customer,
                    'py-[10px] px-[15px] inline-block bg-gray-50 dark:bg-[#15203c] ltr:rounded-r-md rtl:rounded-l-md max-w-[90%] break-words whitespace-pre-wrap': !message.from_our_customer
                  }),
                            innerHTML: _ctx.formatMessageText(message.text)
                          }, null, 10, _hoisted_31))
                ])
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass({
                'block text-xs ltr:text-right rtl:text-left mb-[15px] mt-[5px]': message.from_our_customer,
                'block text-xs ltr:text-left rtl:text-right mb-[15px] mt-[5px]': !message.from_our_customer
              })
              }, _toDisplayString(_ctx.formatTime(message.created_at)), 3)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("form", {
          class: "relative",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("textarea", {
            placeholder: _ctx.directT('chat.writeMessage'),
            class: "w-full h-[50px] resize-none rounded-md text-black dark:text-white bg-gray-50 dark:bg-[#15203c] border border-gray-50 dark:border-[#15203c] transition-all focus:border-primary-500 outline-0 text-xs placeholder:text-gray-500 pt-[16px] ltr:pl-[16px] rtl:pr-[16px] ltr:pr-[150px] rtl:pl-[150px] dark:placeholder:text-gray-400",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.messageText) = $event))
          }, null, 8, _hoisted_33), [
            [_vModelText, _ctx.messageText]
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", {
              class: "emoji-button w-[30px] h-[30px] flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-[#0a0e19] transition-all cursor-pointer relative",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleEmojiPicker && _ctx.toggleEmojiPicker(...args)), ["stop"]))
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("i", { class: "material-symbols-outlined text-[18px]" }, "sentiment_satisfied", -1)
            ])),
            (_ctx.showEmojiPicker)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojiCategories, (category, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        onClick: ($event: any) => (_ctx.currentEmojiCategory = category.id),
                        class: _normalizeClass(["cursor-pointer p-1 text-center flex-1 text-sm hover:bg-gray-100 dark:hover:bg-[#15203c]", { 'bg-gray-100 dark:bg-[#15203c]': _ctx.currentEmojiCategory === category.id }])
                      }, _toDisplayString(category.icon), 11, _hoisted_37))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.emojiCategories.find(c => c.id === _ctx.currentEmojiCategory)?.name || 'אימוג׳ים'), 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentEmojis, (emoji) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: emoji,
                          onClick: _withModifiers(($event: any) => (_ctx.addEmoji(emoji)), ["stop"]),
                          class: "cursor-pointer text-lg hover:bg-gray-100 dark:hover:bg-[#15203c] p-1 rounded text-center"
                        }, _toDisplayString(emoji), 9, _hoisted_41))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "w-[30px] h-[30px] flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 text-white transition-all cursor-pointer",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["stop"]))
            }, [
              _createElementVNode("i", {
                class: "material-symbols-outlined text-[18px]",
                title: _ctx.directT('chat.send')
              }, "send", 8, _hoisted_42)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}